"use strict";

var React = require('react');
var ReactForms = require('react-forms');
var Scalar = ReactForms.schema.Scalar;

var BooleanField = require('ofs/forms/components/boolean-field');
var PriceInput = require('ofs/forms/inputs/price');
var Field = require('ofs/forms/components/better-field');

module.exports = function(props) {
  var className;
  var Component = Field;

  if (!props.input && props.type === 'bool') {
    Component = BooleanField;
    props.input = <input type="checkbox" />;
  } else if (!props.input && props.type === 'price') {
    Component = Field;
    props.type = 'string';
    props.input = <PriceInput />;
  } else if (!props.input) {
    props.input = <input type="text" className="ofs-Input ofs-Input--text" />;
  }

  props.component = <Component className={className} />;
  return Scalar(props);
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/scalars/Scalar.jsx
 **/